<template>
    <div class="content-full">
        <div id="content" class="full fiche">
            <div id="dossiers" class="ecran bloc col-lg-12 col-xs-12" style="display:block;">
                <div class="content-bloc">
                    <div class="title-fiche col-lg-8 col-md-8 col-sm-8 col-xs-8">
                        <font-awesome-icon v-if="request.marker == 'odp_travaux'" icon="wrench"></font-awesome-icon>
                        <font-awesome-icon v-if="request.marker == 'odp_demenagement'" icon="archive"></font-awesome-icon>
                        <font-awesome-icon v-if="request.marker == 'odp_stationnement'" icon="car"></font-awesome-icon>
                        <div class="num_fiche" id="reference">{{ request.ident }}</div>
                        <div class="date_fiche"><span id="date_demande">{{ request.date_demande }}</span></div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right"
                        style="line-height:63px;border-bottom:1px solid #e0e0e0; float: left;">
                        <a v-if="$route.name === 'ficheAssign' && request.etat == 2" id="btn-courrier" class="btnCourrier"
                            @click="createCourrier()" style="margin-right: 10px;"><font-awesome-icon
                                icon="download"></font-awesome-icon> Arrêté</a>
                        <a v-else-if="$route.name === 'ficheAssign' && request.etat == 3" class="btnMerged "
                            @click="openArrete(request.lnk)" style="margin-right: 10px;"><font-awesome-icon
                                icon="file-alt"></font-awesome-icon> Arrêté</a>
                        <a v-b-modal.modal_detail class="btnDetails">Voir le détail</a>
                    </div>
                    <maps></maps>
                    <div class="infos_fiche">
                        <div class="col-lg-3 col-xs-6 demandeur-fiche" style="float:left;">
                            <div class="icn-fiche"><i class="fa fa-user"></i></div>
                            <div class="txt-fiche" id="nom_prenom">{{ request.prenom }} {{ request.nom }}</div>
                        </div>
                        <div class="col-lg-3 col-xs-6 adresse-fiche" style="float:left;">
                            <div class="icn-fiche"><i class="fa fa-map-marker" style="float:left;"></i></div>
                            <div class="txt-fiche">{{ request.adresse_marqueur }}</div>
                        </div>
                        <div class="col-lg-3 col-xs-6 date-entre-fiche" style="float:left;">
                            <div class="icn-fiche"><i class="fa fa-sign-in"></i></div>
                            <div class="txt-fiche" id="date_entree">{{ request.date_deb }}</div>
                        </div>
                        <div class="col-lg-3 col-xs-6 date-sortie-fiche" style="float:left;">
                            <div class="icn-fiche"><i class="fa fa-sign-out"></i></div>
                            <div class="txt-fiche" id="date_sortie">{{ request.date_fin }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="refus" class="ecran bloc col-lg-12 col-md-12 col-sm-12 col-xs-12" v-for="value in refus">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center no-padding title-header"
                    style="float: left;">Refus de la demande
                </div>
                <div class="content-bloc">
                    <div class="infos_fiche">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 demandeur-fiche" style="float: left;">
                            <div class="icn-fiche"><font-awesome-icon icon="calendar"></font-awesome-icon></div>

                            <div class="txt-fiche">{{ value.date_refus }} à {{ value.heure_refus }}</div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 adresse-fiche" style="float: left;">
                            <div class="icn-fiche"><font-awesome-icon icon="comments"></font-awesome-icon></div>
                            <div class="txt-fiche">
                                {{ value.cause_refus }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="modal_detail" size="lg" :title="'Détail de la demande: ' + request.ident" :ok-only="true"
            ok-title="Fermer">
            <div id="content_modal" class="full" style="font-size: 15px;">
                <div class="ecran bloc col-lg-12">
                    <h5>Informations générales</h5>
                    <div class="content-bloc">
                        <b-row>
                            <b-col style="float: left;" cols="12" lg="6"><b>Date de la demande: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.date_demande }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Numéro du dossier: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.ident }}</b-col>
                        </b-row>
                    </div>
                </div>

                <div class="ecran bloc col-lg-12">
                    <h5>Informations du demandeur</h5>
                    <div class="content-bloc">
                        <b-row>
                            <b-col style="float: left;" cols="12" lg="6"><b>Nom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.nom }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Prénom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.prenom }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Adresse: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.adresse }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Code postal: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.code_postal }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Commune: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.ville }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Téléphone: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.telephone }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>E-mail: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.email }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Code Siret: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.siret }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Raison sociale: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.raison_sociale }}</b-col>
                        </b-row>
                    </div>
                </div>

                <div v-if="request.marker === 'odp_demenagement' || request.marker === 'odp_travaux'"
                    class="ecran bloc col-lg-12">
                    <h5>Informations du bénéficiaire</h5>
                    <div class="content-bloc">
                        <b-row>
                            <b-col style="float: left;" cols="12" lg="6"><b>Nom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.nom_beneficiaire }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Prénom: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.prenom_beneficiaire }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Adresse: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.adresse_beneficiaire }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>Téléphone: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.telephone_beneficiaire }}</b-col>

                            <b-col style="float: left;" cols="12" lg="6"><b>E-mail: </b></b-col>
                            <b-col style="float: left;" cols="12" lg="6">{{ request.email_beneficiaire }}</b-col>
                        </b-row>
                    </div>
                </div>

                <template v-if="request.marker === 'odp_travaux'">
                    <travaux :id="request.id"></travaux>
                </template>

                <template v-if="request.marker === 'odp_stationnement'">
                    <stationnement :id="request.id"></stationnement>
                </template>

                <template v-if="request.marker === 'odp_demenagement'">
                    <demenagement :id="request.id"></demenagement>
                </template>
            </div>
        </b-modal>

        <div id="footer"
            v-if="($route.name == 'ficheAssign' && request.etat == 0) || ($route.name == 'ficheModer' && request.avis == '')">
            <div id="footer_accueil" class="barre-footer">
                <ul class="lst-outils">
                    <li @click="assignDemande()" v-if="$route.name == 'ficheAssign' && request.etat == 0"
                        class="col-lg-12 col-md-12 col-sm-12 col-xs-12 green" style="float: left;"><font-awesome-icon
                            icon="paper-plane"></font-awesome-icon> Envoyer</li>
                    <li @click="reponseDemande('refus')" @v-if="$route.name == 'ficheModer' && request.avis == ''"
                        class="col-lg-6 col-md-6 col-sm-6 col-xs-6 red"><font-awesome-icon
                            icon="thumbs-down"></font-awesome-icon> Je refuse</li>
                    <li @click="reponseDemande('accept')" v-if="$route.name == 'ficheModer' && request.avis == ''"
                        class="outils-accept col-lg-6 col-md-6 col-sm-6 col-xs-6 green"><font-awesome-icon
                            icon="thumbs-up"></font-awesome-icon> Je valide</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Vuex from "vuex";
import router from "../router/index.js";
import Vue from "vue";
import Maps from "../components/Maps";
import Travaux from "@/views/Detail/Travaux";
import Stationnement from "@/views/Detail/Stationnement";
import Demenagement from "@/views/Detail/Demenagement";

export default {
    name: "Fiche",
    components: {
        Demenagement,
        Stationnement,
        Travaux,
        maps: Maps
    },
    data() {
        return {
            cou_nom_t: null,
            margins: [],
            isFillPDF: false
        }
    },
    mounted() {
        if (this.$route.name == 'ficheAssign') {
            let params = this.$route.params;
            params.dossier = JSON.parse(localStorage['env_assign']).dos_cod_t;
            this.getRefus(params);
        }
        this.setNeedReturn(true);
    },
    computed: {
        request: {
            get() {
                return this.currentDemande;
            },
            set(value) {
                this.setDemande(value);
            }
        },
        ...Vuex.mapGetters("Demande", ["currentDemande"]),
        ...Vuex.mapGetters("Refus", ["refus"]),
        ...Vuex.mapGetters("Application", ["needReturn"]),
        ...Vuex.mapGetters('Environnement', ['envAssign', 'envModer']),
        ...Vuex.mapGetters('Authentification', ['userConnected'])
    },
    methods: {
        formatDetails(value) {
            return parseInt(value) === 1 ? 'Oui' : 'Non';
        },
        ...Vuex.mapActions("Demande", ["getDemande", "setDemande", 'updateDemande']),
        ...Vuex.mapActions("Refus", ["getRefus"]),
        ...Vuex.mapActions("Application", ["setNeedReturn"]),

        createCourrier() {
            let form = new FormData();
            form.append('dossier', JSON.parse(localStorage['env_assign']).dos_cod_t);
            form.append('marker', this.request.marker);
            form.append('id_dossier', this.request.id);

            Vue.axios.post(window.urlapi + "getDemande.php?mode=courrier", form).then(
                response => {
                    this.margins = response.data.margins;
                    this.cou_nom_t = response.data.cou_nom_t;
                    this.isFillPDF = false;

                    this.fusionCourrier(response.data.data);
                }
            );
        },

        openArrete(lnk) {
            window.open(lnk);
        },

        assignDemande() {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('mode', 'setReponse');
                formData.append('id_dossier', this.request.id);
                formData.append('marker', this.request.marker);
                formData.append('dossier', JSON.parse(localStorage['env_assign']).dos_cod_t);
                formData.append('platform', 'mobile');
                formData.append('userId', this.userConnected.userId);

                Vue.axios.post(window.urlapi + "getDemande.php", formData).then(
                    response => {
                        if (response.data.success) {
                            Vue.prototype.$awn.success(
                                "La demande a été envoyé avec succès"
                            );
                            this.request.etat = 1;
                        }
                        else
                            Vue.prototype.$awn.alert(
                                "Erreur lors de la mise à jour de la demande"
                            );

                        resolve();
                    }
                );
            });
        },

        reponseDemande(reponse) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('id_dossier', this.request.id);
                formData.append('reponse', reponse);
                formData.append('dossier', JSON.parse(localStorage['env_moder']).dos_cod_t);
                formData.append('platform', 'mobile');
                formData.append('layername', this.$route.params.layername);
                formData.append('user_id', this.userConnected.userId);

                Vue.axios.post(window.url_ws + "odpModer.php?action=setReponse&mode=2", formData).then(
                    response => {
                        if (response.data.success) {
                            Vue.prototype.$awn.success(
                                "Votre avis a été enregistré avec succès"
                            );
                            this.request.avis = reponse;
                        }
                        else
                            Vue.prototype.$awn.alert(
                                "Erreur lors de la mise à jour de la demande"
                            );

                        resolve();
                    }
                );
            });
        },

        fusionCourrier(config) {
            config.currentSlaveCode = config.dos_type;
            config.edMode = 'fusion';
            config.gid = config.evt_id;
            config.id = config.cou_id;
            config.mode = 1;
            config.shared = 'Non';

            this.array_to_formData(config);
            this.setTemplate(null, null, config);
        },

        array_to_formData(config) {
            let form = new FormData();

            for (const [key, value] of Object.entries(config))
                form.append(key, value);

            return form;
        },

        setTemplate(fmp, comment, config) {
            let form = new FormData();
            form.append("id", config.cou_id);
            form.append("evt_id", config.evt_id);
            form.append("evt_type", config.evt_type);
            form.append("gid", config.evt_id);
            form.append("dos_id", null);
            form.append("dos_type", config.dos_type);
            form.append("cou_id", config.cou_id);
            form.append("currentSlaveCode", config.dos_type);
            form.append("objet", this.cou_nom_t);
            form.append("shared", config.shared);
            form.append("edMode", config.edMode);
            form.append('dossier', JSON.parse(localStorage['env_assign']).dos_cod_t);

            Vue.axios.post(window.urlapi + "/getCourrier.php", form).then(
                response => {
                    response.data = response.data.data[0];
                    this.loadHTMLTOPDF(
                        '<div>test</div>',
                        this.cou_nom_t,
                        config.evt_id,
                        response.data.hst_cou_id_n,
                        this.cou_nom_t,
                        this.margins,
                        this.isFillPDF,
                        config.evt_type,
                        'true');
                }
            );
        },

        loadHTMLTOPDF(html, text, evtId, couId, objet, margins, fillPDF, type, new_model) {
            let myDosName = Math.floor((Math.random() * 1000000000) + 1),
                passPDF = true;

            margins = margins || {}; //Mise en page
            new_model = new_model || '';

            let sParams = new FormData();

            // sParams.append("html", html);
            sParams.append("typeof", type);
            sParams.append("attachment", '1');
            sParams.append("document", text);
            sParams.append("evtId", evtId);
            sParams.append("objet", objet);
            sParams.append("couId", couId);
            sParams.append("dosName", myDosName);
            sParams.append("dossier", JSON.parse(localStorage['env_assign']).dos_cod_t);
            sParams.append("jsonNotif", 'false');
            sParams.append("new_model", new_model);
            sParams.append("tablename", "");
            sParams.append("isPreview", 'false');
            sParams.append("fromHistory", 'false');
            sParams.append("marginLeft", margins.marginLeft);
            sParams.append("marginTop", margins.marginTop);
            sParams.append("marginRight", margins.marginRight);
            sParams.append("marginBottom", margins.marginBottom);
            sParams.append("footerLeft", margins.footerLeft);
            sParams.append("footerCenter", margins.footerCenter);
            sParams.append("footerRight", margins.footerRight);

            Vue.axios.post(window.urlapi + "/new_courriers.php", sParams).then(
                response => {
                    let office = "f=" + response.data.filename + "&n=" + text;

                    let params = new FormData();
                    params.append("couId", couId);

                    let form = new FormData();
                    form.append("lnk", office);
                    form.append("dossier", JSON.parse(localStorage['env_assign']).dos_cod_t);

                    Vue.axios.post(window.urlapi + "/storeCourrierParams.php", params).then(
                        res => {
                            sessionStorage.setItem('bbl_dos_t', res.data.bbl_dos_t);

                            sessionStorage.setItem('bbl_obj_t', res.data.bbl_obj_t);
                            sessionStorage.setItem('bbl_typ_n', res.data.bbl_typ_n);
                        }
                    );

                    Vue.axios.post(window.urlapi + "/genUnikLnk.php", form).then(
                        res => {
                            this.request.lnk = res.data.lnk;
                            this.request.etat = 3;
                            this.updateDemande(this.request);
                        }
                    );
                }
            );
        }
    }
}
</script>